import { ChevronDown } from "lucide-react";
import { type SelectHTMLAttributes, forwardRef } from "react";
import { cn } from "../cn";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  readonly controlSize?: "sm" | "md";
  readonly wrapperClassName?: string;
}

/** Native select with admin-v2's shared control chrome. */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    { className, wrapperClassName, controlSize = "md", children, ...props },
    ref,
  ) => (
    <span className={cn("relative inline-flex", wrapperClassName)}>
      <select
        ref={ref}
        className={cn(
          "w-full appearance-none rounded-xl border border-input bg-surface pl-3 pr-9 text-sm text-foreground shadow-sm transition-colors hover:bg-muted/50 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/15 disabled:pointer-events-none disabled:opacity-50",
          controlSize === "sm" ? "h-9" : "h-10",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
      />
    </span>
  ),
);
Select.displayName = "Select";
